import { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { NewPromoCategoryCommisionModal } from "./NewPromoCategoryCommisionModal";
import DataGridAmusementServicePromoCategory from "./DataGridAmusementServices";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import { CopyPromoCategoryCommissionModal } from "./CopyPromoCategoryCommissionModal";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";

const Index = () => {
  let location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [showModalPromoCategoryCommision, setShowModalPromoCategoryCommision] = useState(false);
  const [selectedPromoCategoryCommision, setSelectedPromoCategoryCommision] = useState(null);
  const [showModalCopyPromoCategoryCommision, setShowModalCopyPromoCategoryCommision] = useState(false);
  const [cities, setCities] = useState([])

  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPromocategorycommision.getAll({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        const allAmusementCityList = await ApiRegion.getAllCity();
        setCities(allAmusementCityList.map(city =>
        ({
          label: city.id + "-" + city.name,
          value: city.id
        })
        ))
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    const apiData = await ApiPromocategorycommision.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
    tools.setPageNumber(data, searchParams, setValue);
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/promoCategoryCommision?${queryString}`);
  };

  return (
    <div>
      {!_.isEmpty(location.state) && location.state?.neWPromoCategoryCommision ? (
        <NewPromoCategoryCommisionModal />
      ) : (
        <></>
      )}
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت کمیسیون ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست کمیسیون گروه های تخفیف ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <div className="card-toolbar">
              <Button
                onClick={() => {
                  setShowModalCopyPromoCategoryCommision(true);
                }}
                className="mr-4 ml-1"
              >
                <i className="fas fa-copy mr-1 text-small"></i>
                کپی گروه کمیسیون
              </Button>

              <Button
                onClick={() => {
                  setSelectedPromoCategoryCommision(0);
                  setShowModalPromoCategoryCommision(true);
                }}
              >
                <AddCircle className="mr-1" />
                ایجاد گروه کمیسیون جدید
              </Button>
            </div>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridAmusementServicePromoCategory
                    data={listData}
                    cities={cities}
                    setShowModalPromoCategoryCommision={setShowModalPromoCategoryCommision}
                    setSelectedPromoCategoryCommision={setSelectedPromoCategoryCommision}
                  />
                }
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
      {showModalPromoCategoryCommision && (
        <NewPromoCategoryCommisionModal
          showModalPromoCategoryCommision={showModalPromoCategoryCommision}
          setShowModalPromoCategoryCommision={setShowModalPromoCategoryCommision}
          selectedPromoCategoryCommision={selectedPromoCategoryCommision}
          setSelectedPromoCategoryCommision={setSelectedPromoCategoryCommision}
        />
      )}
      {showModalCopyPromoCategoryCommision && (
        <CopyPromoCategoryCommissionModal
          showModalCopyPromoCategoryCommision={showModalCopyPromoCategoryCommision}
          setShowModalCopyPromoCategoryCommision={setShowModalCopyPromoCategoryCommision}
          listData={listData}
        />
      )}
    </div>
  );
};

export default Index;
